export default {
  "ext": "ext.",
  "country": "Telefonnummer land",
  "phone": "Telefon",
  "AB": "Abkhasia",
  "AC": "Ascension Island",
  "AD": "Andorra",
  "AE": "De Forente Arabiske Emirater",
  "AF": "Afghanistan",
  "AG": "Antigua og Barbuda",
  "AI": "Anguilla",
  "AL": "Albania",
  "AM": "Armenia",
  "AO": "Angola",
  "AQ": "Antarctica",
  "AR": "Argentina",
  "AS": "Amerikansk Samoa",
  "AT": "Østerrike",
  "AU": "Australia",
  "AW": "Aruba",
  "AX": "Åland",
  "AZ": "Aserbajdsjan",
  "BA": "Bosnia Hercegovina",
  "BB": "Barbados",
  "BD": "Bangladesh",
  "BE": "Belgia",
  "BF": "Burkina Faso",
  "BG": "Bulgaria",
  "BH": "Bahrain",
  "BI": "Burundi",
  "BJ": "Benin",
  "BL": "Saint Barthélemy",
  "BM": "Bermuda",
  "BN": "Brunei",
  "BO": "Bolivia",
  "BQ": "Bonaire",
  "BR": "Brasil",
  "BS": "Bahamas",
  "BT": "Bhutan",
  "BV": "Bouvetøya",
  "BW": "Botswana",
  "BY": "Hviterussland",
  "BZ": "Belize",
  "CA": "Canada",
  "CC": "Kokosøyene",
  "CD": "Den Demokratiske Republikk Kongo",
  "CF": "Den Sentralafrikanske Republikk",
  "CG": "Kongo",
  "CH": "Sveits",
  "CI": "Elfenbenskysten",
  "CK": "Cookøyene",
  "CL": "Chile",
  "CM": "Kamerun",
  "CN": "Kina",
  "CO": "Colombia",
  "CR": "Costa Rica",
  "CU": "Cuba",
  "CV": "Kapp Verde",
  "CW": "Curaçao",
  "CX": "Christmasøya",
  "CY": "Kypros",
  "CZ": "Tsjekkia",
  "DE": "Tyskland",
  "DJ": "Djibouti",
  "DK": "Danmark",
  "DM": "Dominica",
  "DO": "Den Dominikanske Republikk",
  "DZ": "Algerie",
  "EC": "Ecuador",
  "EE": "Estland",
  "EG": "Egypt",
  "EH": "Vest-Sahara",
  "ER": "Eritrea",
  "ES": "Spania",
  "ET": "Etiopia",
  "FI": "Finland",
  "FJ": "Fiji",
  "FK": "Falklandøyene",
  "FM": "Mikronesia",
  "FO": "Færøyene",
  "FR": "Frankrike",
  "GA": "Gabon",
  "GB": "Storbritannia",
  "GD": "Grenada",
  "GE": "Georgia",
  "GF": "Fransk Guiana",
  "GG": "Guernsey",
  "GH": "Ghana",
  "GI": "Gibraltar",
  "GL": "Grønland",
  "GM": "Gambia",
  "GN": "Guinea",
  "GP": "Guadeloupe",
  "GQ": "Ekvatorial Guinea",
  "GR": "Hellas",
  "GS": "Sør-Georgia",
  "GT": "Guatemala",
  "GU": "Guam",
  "GW": "Guinea-Bissau",
  "GY": "Guyana",
  "HK": "Hong Kong",
  "HM": "Heardøya og McDonaldøyene",
  "HN": "Honduras",
  "HR": "Kroatia",
  "HT": "Haiti",
  "HU": "Ungarn",
  "ID": "Indonesia",
  "IE": "Irland",
  "IL": "Israel",
  "IM": "Man",
  "IN": "India",
  "IO": "Det Britisk Territoriet i Indiahavet",
  "IQ": "Irak",
  "IR": "Iran",
  "IS": "Island",
  "IT": "Italia",
  "JE": "Jersey",
  "JM": "Jamaica",
  "JO": "Jordan",
  "JP": "Japan",
  "KE": "Kenya",
  "KG": "Kirgisistan",
  "KH": "Kambodsja",
  "KI": "Kiribati",
  "KM": "Komorene",
  "KN": "Saint Kitts og Nevis",
  "KP": "Nord-Korea",
  "KR": "Sør-Korea",
  "KW": "Kuwait",
  "KY": "Caymanøyene",
  "KZ": "Kazakhstan",
  "LA": "Laos",
  "LB": "Libanon",
  "LC": "Saint Lucia",
  "LI": "Liechtenstein",
  "LK": "Sri Lanka",
  "LR": "Liberia",
  "LS": "Lesotho",
  "LT": "Litauen",
  "LU": "Luxembourg",
  "LV": "Latvia",
  "LY": "Libya",
  "MA": "Morokko",
  "MC": "Monaco",
  "MD": "Moldova",
  "ME": "Montenegro",
  "MF": "Saint Martin",
  "MG": "Madagaskar",
  "MH": "Marshalløyene",
  "MK": "Makedonien",
  "ML": "Mali",
  "MM": "Myanmar",
  "MN": "Mongolia",
  "MO": "Macau",
  "MP": "Nord-Marianene",
  "MQ": "Martinique",
  "MR": "Mauritania",
  "MS": "Montserrat",
  "MT": "Malta",
  "MU": "Mauritius",
  "MV": "Maldivene",
  "MW": "Malawi",
  "MX": "Mexico",
  "MY": "Malaysia",
  "MZ": "Mosambik",
  "NA": "Namibia",
  "NC": "Ny-Caledonia",
  "NE": "Niger",
  "NF": "Norfolkøya",
  "NG": "Nigeria",
  "NI": "Nicaragua",
  "NL": "Nederland",
  "NO": "Norge",
  "NP": "Nepal",
  "NR": "Nauru",
  "NU": "Niue",
  "NZ": "New Zealand",
  "OM": "Oman",
  "OS": "Sør-Ossetia",
  "PA": "Panama",
  "PE": "Peru",
  "PF": "Fransk Polynesia",
  "PG": "Papua Ny-Guinea",
  "PH": "Filippinene",
  "PK": "Pakistan",
  "PL": "Polen",
  "PM": "Saint Pierre og Miquelon",
  "PN": "Pitcairnøyene",
  "PR": "Puerto Rico",
  "PS": "Palestine",
  "PT": "Portugal",
  "PW": "Palau",
  "PY": "Paraguay",
  "QA": "Qatar",
  "RE": "Réunion",
  "RO": "Romania",
  "RS": "Serbia",
  "RU": "Russland",
  "RW": "Rwanda",
  "SA": "Saudi Arabia",
  "SB": "Salomonøyene",
  "SC": "Seychellene",
  "SD": "Sudan",
  "SE": "Sverige",
  "SG": "Singapore",
  "SH": "Saint Helena",
  "SI": "Slovenia",
  "SJ": "Svalbard og Jan Mayen",
  "SK": "Slovakia",
  "SL": "Sierra Leone",
  "SM": "San Marino",
  "SN": "Senegal",
  "SO": "Somalia",
  "SR": "Surinam",
  "SS": "Sør-Sudan",
  "ST": "São Tomé og Príncipe",
  "SV": "El Salvador",
  "SX": "Sint Maarten",
  "SY": "Syria",
  "SZ": "Swaziland",
  "TA": "Tristan da Cunha",
  "TC": "Turks- og Caicosøyene",
  "TD": "Tsjad",
  "TF": "Den Franske Sørterritoria",
  "TG": "Togo",
  "TH": "Thailand",
  "TJ": "Tadsjikistan",
  "TK": "Tokelau",
  "TL": "Øst Timor",
  "TM": "Turkmenistan",
  "TN": "Tunisia",
  "TO": "Tonga",
  "TR": "Tyrkia",
  "TT": "Trinidad og Tobago",
  "TV": "Tuvalu",
  "TW": "Taiwan",
  "TZ": "Tanzania",
  "UA": "Ukraina",
  "UG": "Uganda",
  "UM": "De små ytre øyene i USA",
  "US": "USA (Amerikas Forente Stater)",
  "UY": "Uruguay",
  "UZ": "Usbekistan",
  "VA": "Den Hellige Stol",
  "VC": "Saint Vincent og Grenadinene",
  "VE": "Venezuela",
  "VG": "De Britiske Jomfruøyene",
  "VI": "Jomfruøyene (U.S.)",
  "VN": "Vietnam",
  "VU": "Vanuatu",
  "WF": "Wallis og Futuna",
  "WS": "Samoa",
  "XK": "Kosovo",
  "YE": "Jemen",
  "YT": "Mayotte",
  "ZA": "Sør-Africa",
  "ZM": "Zambia",
  "ZW": "Zimbabwe",
  "ZZ": "Internasjonal"
}